import TranditionalRaffleWinnerDialog from './tranditionalRaffleWinnerDialog.container'

export default TranditionalRaffleWinnerDialog